'use client';

import profiler from '@/helpers/userProfile';

export const trackEvent = (
	event: string,
	properties: Record<
		string,
		string | boolean | number | Array<string> | object
	> = {},
) => {
	// Ensure heap is present
	if (!window.heap) return false;

	const [userProfile] = profiler();
	const id = userProfile?.mtaAid;

	window.heap.track(event, {
		MTAAnonymousID: id,
		...properties,
	});

	return true;
};
